import React, { useState } from 'react';
import './Navigation.css';
import {
  FaAngleDown as AngleDown, FaAngleRight as AngleRight,
  FaQuestionCircle as QuestionCircle,
} from 'react-icons/lib/fa';
import { NavLink } from 'react-router-dom';
import { t } from 'i18next';
import ReactTooltip from 'react-tooltip';
import { toggleSidebar } from '../../reducer/actions';
import { ANALYTICS_WRITE_ROLES } from '../../constants';

const Navigation = ({ isPremium, dispatch, session }) => {
  const [visible, setVisible] = useState(true);
  const [analyticsVisible, setAnalyticsVisible] = useState(false);
  const [analyticsVisibleDev, setAnalyticsVisibleDev] = useState(false);

  const onArrowClickhandler = () => {
    setVisible(! visible);
  };

  const toggleAnalyticsVisibility = () => {
    setAnalyticsVisible(! analyticsVisible);
  };

  const toggleAnalyticsVisibilityDev = () => {
    setAnalyticsVisibleDev(! analyticsVisibleDev);
  };

  return (
    <div className="Navigation">
      <NavLink to="/overview" onClick={() => dispatch(toggleSidebar())} activeClassName="active">
        {t('overview')}
      </NavLink>

      { isPremium && process.env.REACT_APP_BILLING_DATA_FEATURE_ENABLED === 'true' && (
        <NavLink to="/devices" onClick={() => dispatch(toggleSidebar())}>
          {t('metering')}
        </NavLink>
      )}

      <div className="navigationTitle">
        <a onClick={() => onArrowClickhandler()}>
          {visible ? <AngleDown size="26" /> : <AngleRight size="26" />}
          {t('advancedReports')}
          <QuestionCircle size="21" className="questionCircle" data-for="advanced_reports"
            data-tip={t('advancedReportsTooltip')}
            onClick={(e) => { e.stopPropagation(); }}
          />
          <ReactTooltip id="advanced_reports" place="top" type="dark"
            effect="solid" offset={{
              left: -100,
              top: 5,
            }} className="tooltip"
            html border
          />
          { process.env.REACT_APP_REPORTS_SERVICE_URL.includes('dev')
            ? '' : <div className="version">(Beta)</div> }
        </a>

      </div>
      {visible && (
        <div className="advancedReportsContent">
          {isPremium && (ANALYTICS_WRITE_ROLES.includes(session.role)) && (
            <NavLink to="/downloadDeviceReport" onClick={() => dispatch(toggleSidebar())} activeClassName="active">
              {t('downloadDeviceReport')}
            </NavLink>
          )}
          {isPremium && (
            <NavLink to="/onboardingAnalysis" onClick={() => dispatch(toggleSidebar())} activeClassName="active">
              {t('onboardingAnalysis')}
            </NavLink>
          )}
          {isPremium && (
            <NavLink to="/deviceTrends" onClick={() => dispatch(toggleSidebar())} activeClassName="active">
              {t('deviceTrends')}
            </NavLink>
          )}
          {isPremium && (
            <NavLink to="/deviceSWAnalysis" onClick={() => dispatch(toggleSidebar())} activeClassName="active">
              {t('softwareAnalysis')}
            </NavLink>
          )}
          {isPremium && (
            <NavLink to="/DeviceUsageAnalysis" onClick={() => dispatch(toggleSidebar())} activeClassName="active">
              {t('deviceUsageAnalysis')}
            </NavLink>
          )}
          {isPremium && (
            <NavLink to="/deviceDetails" onClick={() => dispatch(toggleSidebar())} activeClassName="active">
              {t('deviceDetails')}
            </NavLink>
          )}
          {isPremium && (
            <NavLink to="/userAnalysis" onClick={() => dispatch(toggleSidebar())} activeClassName="active">
              {t('userAnalysis')}
            </NavLink>
          )}
          {isPremium && (
            <NavLink to="/notificationAnalysis" onClick={() => dispatch(toggleSidebar())} activeClassName="active">
              {t('notificationAnalysis')}
            </NavLink>
          )}
          {isPremium && (
            <NavLink to="/datapointTransmissionTrends"
              onClick={() => dispatch(toggleSidebar())} activeClassName="active"
            >
              {t('datapointTransmissionTrends')}
            </NavLink>
          )}
        </div>
      )}
      { process.env.REACT_APP_ANALYTIC_FEATURES_ENABLED === 'true' && (
      <>
        <div className="navigationTitle tensorAnalyticsSection">
          <a role="presentation" onClick={() => toggleAnalyticsVisibility()}>
            {analyticsVisible ? <AngleDown size="26" /> : <AngleRight size="26" />}
            {t('analytics')}
            <QuestionCircle size="21"
              className="questionCircle"
              data-for="analytics"
              data-tip={t('Empower your platform with the insight of machine learning')}
              onClick={(e) => { e.stopPropagation(); }}
            />
            <ReactTooltip id="analytics"
              place="top"
              type="dark"
              effect="solid"
              offset={{
                left: -60,
                top: 5,
              }}
              className="tooltip"
              html
              border
            />
            <div className="version" />

          </a>

        </div>
        {analyticsVisible && (
          <div className="analyticsContent">
            {isPremium && (
              <NavLink to="/analyticsDashboard"
                onClick={() => dispatch(toggleSidebar())}
                activeClassName="active"
              >
                {t('tensorAnalytics Dashboard')}
              </NavLink>
            )}
            {isPremium && (
              <NavLink to="/schedules"
                onClick={() => dispatch(toggleSidebar())}
                activeClassName="active"
              >
                {t('Schedules')}
              </NavLink>
            )}
            {isPremium && (
              <NavLink to="/models"
                onClick={() => dispatch(toggleSidebar())}
                activeClassName="active"
              >
                {t('Models')}
              </NavLink>
            )}

          </div>

        )}
        <div className="navigationTitle tensorAnalyticsSectionDev">
          <a role="presentation" onClick={() => toggleAnalyticsVisibilityDev()}>
            {analyticsVisibleDev ? <AngleDown size="26" /> : <AngleRight size="26" />}
            {`${t('analytics')} (DEV)`}
            <QuestionCircle size="21"
              className="questionCircle"
              data-for="analytics"
              data-tip={t('Empower your platform with the insight of machine learning')}
              onClick={(e) => { e.stopPropagation(); }}
            />
            <ReactTooltip id="analyticsDev"
              place="top"
              type="dark"
              effect="solid"
              offset={{
                left: -60,
                top: 5,
              }}
              className="tooltip"
              html
              border
            />
            <div className="version" />

          </a>

        </div>
        {analyticsVisibleDev && (
          <div className="analyticsContent">
            {isPremium && (
              <NavLink to="/analyticsDashboardDev"
                onClick={() => dispatch(toggleSidebar())}
                activeClassName="active"
              >
                {t('tensorAnalytics Dashboard')}
              </NavLink>
            )}
            {isPremium && (
              <NavLink to="/schedulesDev"
                onClick={() => dispatch(toggleSidebar())}
                activeClassName="active"
              >
                {t('Schedules')}
              </NavLink>
            )}
            {isPremium && (
              <NavLink to="/modelsDev"
                onClick={() => dispatch(toggleSidebar())}
                activeClassName="active"
              >
                {t('Models')}
              </NavLink>
            )}

          </div>
        )}
      </>
      )}

    </div>
  );
};

export default Navigation;
